<template>
  <div class="location">
    <div class="control-width mx-auto">
      <div class="p-4 p-md-5 border shadow-sm add-rounded">
        <h4 class="mb-3 font-weight-bold kova-text">Bio</h4>
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Full name</h6>

        <a-input
          size="large"
          placeholder="John Doe"
          v-model="fullName"
          class="mx-auto mb-3"
        />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Phone number</h6>

        <a-input
          size="large"
          v-model="phone"
          placeholder
          class="mx-auto mb-3"
        />
        <br />
        <h6 class="mb-3 font-weight-bold text-left mt-4">Timezone</h6>

        <a-select
          class="w-100 mt-4 mb-5"
          size="large"
          v-model="timezone"
          placeholder="Select Timezone"
        >
          <a-select-option value="-12:00"
            >(GMT -12:00) Eniwetok, Kwajalein</a-select-option
          >
          <a-select-option value="-11:00"
            >(GMT -11:00) Midway Island, Samoa</a-select-option
          >
          <a-select-option value="-10:00">(GMT -10:00) Hawaii</a-select-option>
          <a-select-option value="-09:50">(GMT -9:30) Taiohae</a-select-option>
          <a-select-option value="-09:00">(GMT -9:00) Alaska</a-select-option>
          <a-select-option value="-08:00"
            >(GMT -8:00) Pacific Time (US &amp; Canada)</a-select-option
          >
          <a-select-option value="-07:00"
            >(GMT -7:00) Mountain Time (US &amp; Canada)</a-select-option
          >
          <a-select-option value="-06:00"
            >(GMT -6:00) Central Time (US &amp; Canada), Mexico
            City</a-select-option
          >
          <a-select-option value="-05:00"
            >(GMT -5:00) Eastern Time (US &amp; Canada), Bogota,
            Lima</a-select-option
          >
          <a-select-option value="-04:50">(GMT -4:30) Caracas</a-select-option>
          <a-select-option value="-04:00"
            >(GMT -4:00) Atlantic Time (Canada), Caracas, La
            Paz</a-select-option
          >
          <a-select-option value="-03:50"
            >(GMT -3:30) Newfoundland</a-select-option
          >
          <a-select-option value="-03:00"
            >(GMT -3:00) Brazil, Buenos Aires, Georgetown</a-select-option
          >
          <a-select-option value="-02:00"
            >(GMT -2:00) Mid-Atlantic</a-select-option
          >
          <a-select-option value="-01:00"
            >(GMT -1:00) Azores, Cape Verde Islands</a-select-option
          >
          <a-select-option value="+00:00" selected="selected"
            >(GMT) Western Europe Time, London, Lisbon,
            Casablanca</a-select-option
          >
          <a-select-option value="+01:00"
            >(GMT +1:00) Brussels, Copenhagen, Madrid, Paris, West
            Africa</a-select-option
          >
          <a-select-option value="+02:00"
            >(GMT +2:00) Kaliningrad, South Africa</a-select-option
          >
          <a-select-option value="+03:00"
            >(GMT +3:00) Baghdad, Riyadh, Moscow, St.
            Petersburg</a-select-option
          >
          <a-select-option value="+03:50">(GMT +3:30) Tehran</a-select-option>
          <a-select-option value="+04:00"
            >(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</a-select-option
          >
          <a-select-option value="+04:50">(GMT +4:30) Kabul</a-select-option>
          <a-select-option value="+05:00"
            >(GMT +5:00) Ekaterinburg, Islamabad, Karachi,
            Tashkent</a-select-option
          >
          <a-select-option value="+05:50"
            >(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</a-select-option
          >
          <a-select-option value="+05:75"
            >(GMT +5:45) Kathmandu, Pokhara</a-select-option
          >
          <a-select-option value="+06:00"
            >(GMT +6:00) Almaty, Dhaka, Colombo</a-select-option
          >
          <a-select-option value="+06:50"
            >(GMT +6:30) Yangon, Mandalay</a-select-option
          >
          <a-select-option value="+07:00"
            >(GMT +7:00) Bangkok, Hanoi, Jakarta</a-select-option
          >
          <a-select-option value="+08:00"
            >(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</a-select-option
          >
          <a-select-option value="+08:75">(GMT +8:45) Eucla</a-select-option>
          <a-select-option value="+09:00"
            >(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</a-select-option
          >
          <a-select-option value="+09:50"
            >(GMT +9:30) Adelaide, Darwin</a-select-option
          >
          <a-select-option value="+10:00"
            >(GMT +10:00) Eastern Australia, Guam, Vladivostok</a-select-option
          >
          <a-select-option value="+10:50"
            >(GMT +10:30) Lord Howe Island</a-select-option
          >
          <a-select-option value="+11:00"
            >(GMT +11:00) Magadan, Solomon Islands, New
            Caledonia</a-select-option
          >
          <a-select-option value="+11:50"
            >(GMT +11:30) Norfolk Island</a-select-option
          >
          <a-select-option value="+12:00"
            >(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</a-select-option
          >
          <a-select-option value="+12:75"
            >(GMT +12:45) Chatham Islands</a-select-option
          >
          <a-select-option value="+13:00"
            >(GMT +13:00) Apia, Nukualofa</a-select-option
          >
          <a-select-option value="+14:00"
            >(GMT +14:00) Line Islands, Tokelau</a-select-option
          >
        </a-select>

        <br />

        <div class="container-fluid px-0 px-md-4 mb-5 mt-5">
          <div class="row">
            <div class="col text-left">
              <button
                class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded"
                v-on:click="goBack"
              >
                Back
              </button>
            </div>
            <div class="col text-right">
              <router-link to="/job-review">
                <button
                  class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded"
                  v-on:click="next"
                >
                  Next
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right kova-text pt-3 mr-4 mb-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "job-bio",
  data() {
    return {
      fullName: this.$store.state.fcjob.fcjobData.fullName,
      phone: this.$store.state.fcjob.fcjobData.phone,
      timezone: this.$store.state.fcjob.fcjobData.timezone
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    next() {
      const { fullName, phone, timezone } = this;
      this.$store.commit("fcjob/updateFcJob", {
        fullName,
        phone,
        timezone
      });
      this.$router.push("job-review");
    },
    skip() {
      this.$router.push("job-review");
    }
  },
  mounted() {}
};
</script>
<style scoped>
.control-width {
  width: 600px;
}

@media (min-width: 768px) and (max-width: 991px) {
}
@media (max-width: 767px) {
  .control-width {
    width: 500px;
  }
}
@media (max-width: 550px) {
  .control-width {
    width: 98%;
  }
}
</style>
